import React, { useState } from "react";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import logo from "../Image/Logo3d.png";
import { db } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AppStore from "../Image/Play-Store.png";
import PlayStore from "../Image/App-Store.png";

const Footer = () => {
  const { t } = useTranslation();
  const [mobileNumber, setMobileNumber] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const today = new Date();
  const year = today.getFullYear();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phonePattern = /^[0-9]{10}$/;
    if (phonePattern.test(mobileNumber.trim())) {
      try {
        const mobileCollection = collection(db, "subscribed_mobile_numbers");
        await addDoc(mobileCollection, {
          mobileNumber: mobileNumber,
          timestamp: new Date(),
        });

        alert(t("footer.subscriptionSuccess"));
        setMobileNumber("");
      } catch (error) {
        console.error("Error adding document: ", error);
        alert(t("footer.subscriptionError"));
      }
    } else {
      alert(t("footer.enterValidMobileNumber"));
    }
  };

  const handleNavClick = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
      setTimeout(() => {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footerBG text-Dark">
      <Container>
        <section className="py-lg-4 py-md-4 py-sm-4 py-4">
          <Row className="pt-lg-4 pt-md-0 pt-sm-0">
            <Col
              lg={3}
              md={6}
              sm={12}
              xs={12}
              className="order-lg-1 order-md-1 order-sm-1 order-1 mb-0 mb-lg-0 mb-4"
            >
              <div className="footer_head">
                <div className="footer_Logo d-flex align-items-center justify-content-lg-start justify-content-md-start justify-content-center mb-3 mt-lg-0 mt-md-0 mt-sm-0 mt-0">
                  <img
                    as={Link}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick("home");
                    }}
                    src={logo}
                    className="footerLogo"
                    alt="Logo"
                  />
                </div>

                <div className="m-0 text-lg-start text-md-start text-center">
                  <p className="footerheading1 m-0">{t("footer.slogan")}</p>
                </div>
              </div>
            </Col>

            <Col
              lg={2}
              md={3}
              sm={6}
              xs={6}
              className="order-lg-3 order-md-3 order-sm-3 order-3"
            >
              <div className="footer-widget pt-2">
                <h4 className="mb-4">{t("footer.aboutUs")}</h4>
                <ul className="link list-unstyled">
                  <li className="mb-1">
                    <button
                      className="Footerlinks"
                      onClick={() => handleNavClick("home")}
                    >
                      {t("home")}
                    </button>
                  </li>
                  <li className="mb-1">
                    <button
                      className="Footerlinks"
                      onClick={() => handleNavClick("features")}
                    >
                      {t("features")}
                    </button>
                  </li>
                  <li className="mb-1">
                    <button
                      className="Footerlinks"
                      onClick={() => handleNavClick("aboutus")}
                    >
                      {t("about_Us")}
                    </button>
                  </li>
                  <li className="mb-1">
                    <button
                      className="Footerlinks"
                      onClick={() => handleNavClick("howItWorks")}
                    >
                      {t("howItWorks")}
                    </button>
                  </li>
                  <li className="mb-1">
                    <button
                      className="Footerlinks"
                      onClick={() => handleNavClick("testimonials")}
                    >
                      {t("testimonials")}
                    </button>
                  </li>
                  <li className="mb-1">
                    <Link to="/Blog" className="Footerlinks">
                      {t("blogs")}
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>

            <Col
              lg={2}
              md={3}
              sm={6}
              xs={6}
              className="order-lg-3 order-md-3 order-sm-3 order-3"
            >
              <div className="footer-widget pt-2">
                <h4 className="mb-4">{t("footer.information")}</h4>
                <ul className="link list-unstyled">
                  <li className="mb-1">
                    <a
                      variant="link"
                      href="https://nityamala.com/privacypolicy/"
                      className="Footerlinks"
                    >
                      {t("footer.privacyPolicyBtn")}
                    </a>
                  </li>
                  <li className="mb-1">
                    <a
                      variant="link"
                      href="https://nityamala.com/Deleteaccountrequest/"
                      className="Footerlinks"
                    >
                      {t("footer.deleteAccountBtn")}
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            <Col
              lg={2}
              md={6}
              sm={6}
              xs={12}
              className="order-lg-4 order-md-4 order-sm-4 order-4"
            >
              <div className="footer-widget pt-2">
                <h4 className="mb-4">{t("footer.otherservices")}</h4>
                <ul className="p-0">
                  <h4 className="mb-3 footer_nityamala_txt">
                    {t("footer.nityamalafooter")}
                  </h4>
                  <div className="footer_App_download_img">
                    <div className="mb-1">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.nitya.mala.app"
                        className="mb-30 app-store mobile-hide"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          className="download_app_img"
                          src={AppStore}
                          alt="Logo"
                        />
                      </a>
                    </div>
                    <div>
                      <a
                        href="https://apps.apple.com/app/nitya-mala/id6740871116"
                        className="mb-30 play-store mobile-hide"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          className="download_app_img"
                          src={PlayStore}
                          alt="Logo"
                        />
                      </a>
                    </div>
                  </div>
                </ul>
              </div>
            </Col>

            <Col
              lg={3}
              md={6}
              sm={6}
              xs={12}
              className="order-lg-5 order-md-5 order-sm-5 order-5"
            >
              <div className="footer-widget">
                <h4 className="mb-4">{t("footer.connectwithus")}</h4>
                <ul className="ps-0 list-unstyled">
                  <li>
                    <p>{t("footer.subscribeOur")}</p>
                  </li>
                  <form onSubmit={handleSubmit}>
                    <InputGroup className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder={t("footer.mobile_placeholder")}
                        aria-label="Recipient's mobile number"
                        aria-describedby="button-addon2"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        className="shadow-none"
                        required
                      />
                      <Button
                        className="Footer_email_arrow"
                        id="button-addon2"
                        type="submit"
                      >
                        <i className="bi bi-arrow-right text-white"></i>
                      </Button>
                    </InputGroup>
                  </form>
                </ul>
              </div>
              <div className="social_container_footer d-flex align-items-center justify-content-lg-start justify-content-md-start justify-content-center mt-3 p-0">
                <a
                  href="https://www.facebook.com/share/18A1jXhsSW/"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/nityamala_51?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  className="social-icon_footer"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://youtube.com/@nityamala?si=aPVdgzgspapoDRTc"
                  className="social-icon_footer"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <a
                  href="https://t.me/Nityamala"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-telegram"></i>
                </a>
                <a
                  href="https://www.threads.net/@nityamala_51"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-threads"></i>
                </a>
                <a
                  href="https://chat.whatsapp.com/IwRsf8xXaxRErZzn8sVJ1d"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon_footer"
                >
                  <i className="bi bi-whatsapp"></i>
                </a>
              </div>
            </Col>
          </Row>
        </section>

        <Row className="py-2 py-lg-3 py-md-3 px-3 footer-border-top">
          <Col
            lg={12}
            md={12}
            className="justify-content-center align-items-center d-flex p-0"
          >
            <p className="footerendline text-center m-0">
              {t("footer.copyright")} {year}  
              <a
                href="/"
                className="footer01 text-dark text-decoration-none mx-1"
              >
              {t("footer.NityaMalaApp")}
              </a>
              {t("footer.PoweredBy")}
              <a
                className="ms-1 text-decoration-none"
                target="_blank"
                rel="noreferrer"
                href="https://liontouchwebpark.com/"
              >
              {t("footer.LiontouchWebpark")}
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
